<template>
    <div class="examBox-details" id="examBox-details">
        <div class="exam-details-top">
            <div :style="{height:statusBarHeight+'px',background:'#fff'}"></div>
            <van-nav-bar
                :title="examdata.name?examdata.name :''"
                left-arrow
                @click-left="backChange1"
            />
        </div>
        <div v-if="isfacedialog && examdata">
            <facedialog
                :trainItemExamId="+filter.id"
                :businessType="+getexamparams.type"
                :examId="examdata.examId"
                :businessId="+getexamparams.trainId"
                :faceType="faceType"
                :isPop="isPop"
                @close="close"
            ></facedialog>
        </div>
        <div class="exam-details-contentbox" v-if="examdataShow">
            <div class="exam-details-content">
                <p class="exam-details-ks" v-if="frontendConfig == 'true'">{{examdata.type === 1?'模拟考试':'正式考试'}}</p>
                <!-- -1 待判定，0 不及格，1 及格, 2 未作答, 3 学员不查看成绩 -->
                <p class="exam-details-ico" v-if="[0,1,2].includes(examdata.result)">
                    <img :src="showstatus(examdata.result)" />
                </p>
                <ul class="exam-details-msg">
                    <li class="alltopic">
                        总题数
                        <span>{{examdata.totalQuestionNum}}</span>
                    </li>
                    <li class="totalscore">
                        总分值
                        <span>
                            {{examdata.totalScore}}
                        </span>
                    </li>
                    <li class="passline">
                        及格线
                        <span>
                            {{examdata.passingScore}}
                        </span>
                    </li>
                    <li class="examtime">
                        考试时长
                        <span>
                            {{examdata.duration}}
                        </span>
                    </li>
                </ul>
                <div :class="examdata.ifEnd === 1 ? 'overduebg' : 'nooverduebg'"  class="exam-details-time">
                    <div class="details-time-left">
                        <p class="exam-details-title">
                            考试日期：
                            <span v-show="examdata.ifEnd === 1">已结束</span>
                        </p>
                        <p
                            class="exam-time"
                            v-if="examdata.examStartDate"
                        >{{examdata.examStartDate.slice(0, -3)}} 至 {{examdata.examEndDate.slice(0, -3)}}</p>
                        <p
                            class="exam-time"
                            v-if="examdata.regularDate && examdata.isLimitTime==2"
                        >每月定期（{{examdata.regularDate}}）</p>
                        <p
                            class="exam-time"
                            v-if="examdata.isLimitTime==0"
                        >长期有效</p>
                    </div>
                    <div class="details-time-right">
                        <img src="../../../assets/images/exam/examDate@2x.png" alt="">
                    </div>

                </div>
                <div class="examination-record-box">
                    <div class="examination-record-content">
                        <div class="examination-record-title">
                            <p class="text">历史考试记录</p>
                            <div @click="showclick">
                                <svg-icon icon-class="tip-icon" class-name="tip-icon"></svg-icon>
                            </div>
                        </div>
                        <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text=" 一 已经到底了，更多内容即将上线 一 "
                            :immediate-check="false"
                            ref="list"
                            @load="onLoad"
                            v-show="examlist.length"
                        >

                            <ul>
                                <li
                                    v-for="(item,index) in examlist"
                                    :key="index"
                                    @click="examResultsUrl(item.id, item)"
                                >

                                    <p class="examination-record-time1">
                                        用时：<span :class="item.scoreAuth || (!item.scoreAuth && !item.isReadOver) ? 'examination-record-shiji marginRight' : 'examination-record-shiji'">{{item.useDuration}}</span>
                                        <span v-if="item.scoreAuth">
                                            得分：
                                            <i v-if="!item.isReadOver"><label>阅卷中</label></i>
                                            <i v-else><label>{{item.score}}</label>分</i>
                                            <span v-if="(item.paperType == 1 && !item.isValid) || (item.paperType == 2 && item.isReadOver && !item.isValid)" class="valid">(异常)</span>
                                        </span>
                                        <span v-if="!item.scoreAuth && !item.isReadOver">
                                            得分：
                                            <i><label>阅卷中</label></i>
                                        </span>
                                        <!-- <span v-else>
                                            得分：
                                            <label>违规成绩无效</label>
                                        </span> -->
                                        <svg-icon v-if="item.cheat == 1 &&  item.isReadOver == 1" icon-class="weigui1" class-name="icon-img"></svg-icon>
                                    </p>
                                    <p class="examination-record-time">{{item.examStartTime}}</p>
                                    <div class="examination-record-right">
                                        <svg-icon icon-class="left-arrow-icon" class-name="left-arrow-icon"></svg-icon>
                                    </div>
                                </li>
                            </ul>
                        </van-list>
                        <div v-if="!examlist.length && isnohistorydata" class="noexam">
                            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/exam/nohistorydata%402x.png" alt="">
                            <p>暂无考试记录</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="exam-details-footer" v-if="examdata.ifEnd !== 1">
            <p v-if="examdata.ifStart === 0" class="exam-details-btn">
                <span>考试尚未开始</span>
            </p>
            <p
                v-if="examdata.ifStart === 1 && examlist.length === 0 && examdata.leftExamNum !== 0"
                class="exam-start"
                @click="exampath(1)"
            >
                <span>进入考场</span>

            </p>
            <p v-if="examdata.ifStart === 1 && examlist.length > 0 && examdata.leftExamNum !== 0" :class="examdata.result === 1 ? 'exam-details-btn1' : 'exam-start'"
                @click="exampath"> 重考
            </p>
            <p
                v-if="examdata.ifStart === 1 && examdata.leftExamNum === 0 && examdata.totalExamNum!==0"
                class="exam-details-btn"
            >
                <span>考试机会已用完</span>
            </p>
            <p  v-if="examdata.totalExamNum !== 0"
                class="exam-num"
            >
                <span>
                    (已考：{{examdata.totalExamNum - examdata.leftExamNum || 0}}次
                    / 共{{examdata.totalExamNum}}次)
                </span>
            </p>
            <div :style="{height:bottomSafeHeight+'px'}"></div>
        </div>
        <van-dialog class="traindialog" v-model="lockedTipDialog" :show-confirm-button="false">
            <div class="traindialog-content">{{lockedTip}}</div>
            <van-button class="traindialog-btn" @click="lockedTipClick">知道了（{{count}}S后关闭）</van-button>
        </van-dialog>
    </div>
</template>

<script>
import md5 from "js-md5";
import facedialog from "../../../layout/facedialog.vue";
import axios from '../../../libs/heartAxios'
import SDK from '@wd/lowcode-h5'
export default {
    name: "examlistDetails",
    components: {
        facedialog,
    },
    data() {
        return {
            frontendConfig:false,
            isnohistorydata:false,
            isfacedialog: false,
            faceType:'1',
            examdataShow: false,
            lockedTipDialog:false,
            count:2,
            examdata: {},
            lockedTip:'',
            examlist: [],
            isReal: false,
            img1: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/exam/pass%402x.png',
            img2: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/exam/nopass%402x.png',
            img3: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/exam/noanwser%402x.png',
            filter: {
                pageNum: 1,
                pageSize: 10,
                id: ""
            },
            trainId: "",
            getexamparams: {},
            // 按钮节流
            stopClickLogin: false,
            heartbeatTimer:null, //记录在线人数定时器
            loading:false,// 历史记录加载
            finished: false,
            statusBarHeight:0,
            bottomSafeHeight:0,
            isPop:false,// 判断上次是否有一场正在进行中的考试
            userPaperId:'',
        };
    },
    filters: {},
    async created() {
        console.log('23222')
        this.filter.id = this.$route.query.trainItemExamId;
        this.trainId = this.$route.query.trainId;
        this.getexamparams = this.$route.query;
        await this.findExamListByIds();

        this.isRealNameAuthentication();
       let frontendConfigList =  SDK.getConfigruation(this).frontendConfig;
       console.log('frontendConfigList--->',frontendConfigList)
       frontendConfigList.map(item=>{
           console.log('item.key--->', item.key)
           if(item.key == 'examTag'){
               console.log('item---->777', item)
               this.frontendConfig = item.value;
           }
       })
        // setTimeout(function(){
        //     if(localStorage.getItem('type')=='iOS'){
        //         if(localStorage.getItem('statusBarHeight')){ // 是在iOS内
        //             document.getElementById('examBox-details').style.paddingTop= localStorage.getItem('statusBarHeight') +'px'
        //             document.getElementById('examBox-details').style.boxSizing='border-box'
        //         }
        //     }
        // },600)
    },
    watch:{
         lockedTipDialog: {
            handler(n) {
               if(n===true && this.count>0){
                    let clear=setInterval(()=>{
                        this.count--;
                        if(this.count<=0){
                            this.lockedTipDialog=false;
                            clearInterval(clear);
                        }
                    },1000);
               }
            },
            immediate: true
        },
    },
    mounted() {
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.backChange1, false); //false阻止默认事件
        }
        this.sendHeartbeat();//10秒发送一次,记录在线人数
        this.findUserPaperListById();
        sessionStorage.removeItem("historyExamInfo");
        sessionStorage.removeItem("autoTime");
        sessionStorage.removeItem("examStatus");
        if(localStorage.getItem('type') == 'iOS') {
            this.statusBarHeight = localStorage.getItem("statusBarHeight");
            this.bottomSafeHeight = localStorage.getItem("bottomSafeHeight");
        }
    },
    beforeRouteEnter(to, from, next) {
        const previewArea = sessionStorage.getItem('previewArea')
        // 用于hack处理在考试回显时，预览文件后，点击返回，会直接返回到该页面
        if(previewArea) {
            sessionStorage.removeItem('previewArea')
            next({ path:from.fullPath })
        }else{
            next()
        }
    },
    destroyed() {
        window.removeEventListener("popstate", this.backChange1, false); //false阻止默认事件
        if(this.heartbeatTimer){
          clearInterval(this.heartbeatTimer)
        }
    },
    methods: {
        /**
         * 上锁事件
         */
        lockedTipClick(){
            this.lockedTipDialog = false;
        },
        sendHeartbeat(){
            let option = {
                url: "/exam/v1/data/sendHeartbeat",
                params: { examId:this.filter.id }
            };
            axios(option)

            this.heartbeatTimer = setInterval(() => {
                let option = {
                    url: "/exam/v1/data/sendHeartbeat",
                    params: { examId:this.filter.id }
                };
                axios(option)
            }, 10000);
        },
        showstatus(val) {
            if (val === 0) {
                return this.img2;
            } else if (val === 1) {
                return this.img1;
            } else if (val === 2) {
                return this.img3;
            }
        },
        backChange1() {
                if(+this.$route.query.backType === 3) {
                    if(this.$isapp && this.$publicFn.getUserAgent(false) != 'h5') {
                        return this.$WDJSBridge.useBack()
                    }
                    this.$router.replace({
                        name: "myExam",
                    });
                } else if(+this.$route.query.backType === 4) {
                    this.$router.push({
                        path: '/learning',
                        query: {
                            backType: this.$route.query.backType,
                        }
                    })
                } else if(+this.$route.query.type === 2) {
                    if(this.$isapp) return this.$WDJSBridge.useBack()
                    this.$router.push({
                        path: '/learning/task/detail',
                        query: {
                            id: this.$route.query.trainId,
                            backType: this.$route.query.backType,
                            backPath: this.$route.query.backPath,
                            goodsId:this.$route.query.goodsId,
                            goodsKind:this.$route.query.goodsKind,
                        }
                    });
                } else if(+this.$route.query.type === 1) {
                    this.$router.push({
                        name: "learningDetails",
                        query: { id: this.$route.query.trainId, backType: this.$route.query.backType, }
                    });
                }
        },
        showclick() {
            this.$dialog
                .alert({
                    message: "异常退出的考试，考试记录会延迟显示，请耐心等待",
                    theme: "round-button",
                    confirmButtonText: "我知道了",
                    confirmButtonColor: "#FFFFFF",
                    className: "showclass"
                })
        },
        isRealNameAuthentication() {
            this.$api.exam.isRealNameAuthentication({}).then(data => {
                const userInfo = localStorage.getItem("token");
                this.isReal =
                    data.code === 0 &&
                    md5(userInfo + "true") === data.data;
                    console.log(this.isReal)
            });
        },
        /**
         * 上拉加载
         */
        onLoad() {
            this.filter.pageNum = this.filter.pageNum*1 + 1
            this.isLoad = true;
            this.findUserPaperListById('reachBottom')
        },

        timeFormatter(time) {
            const hours = Math.floor(time / 60 / 60);
            const minutes = Math.floor((time / 60) % 60);
            const seconds = Math.floor(time % 60);
            var hours1 = hours < 10 ? "0" + hours : hours;
            var minutes1 = minutes < 10 ? "0" + minutes : minutes;
            var seconds1 = seconds < 10 ? "0" + seconds : seconds;
            return hours1 + "时" + minutes1 + "分" + seconds1 + "秒";
        },
        findUserPaperListById(type) {
            let params = {
                bussinessId: this.getexamparams.trainId,
                examId: this.getexamparams.contentId || this.getexamparams.trainItemExamId,
                pageNum: this.filter.pageNum,
                pageSize: this.filter.pageSize,
                type: this.getexamparams.type
            }
            this.$api.exam
                .findUserPaperListById({
                    params
                })
                .then((res) => {
                    if(res.data && res.data.list){
                        res.data.list.forEach(item => {
                            item.useDuration = this.timeFormatter(item.useDuration);
                        });
                        if (type === "reachBottom") {
                            this.examlist = this.examlist.concat(res.data.list);
                        } else {
                            this.examlist = res.data.list;
                        }
                        this.total = res.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        this.finished = res.data.isLastPage;
                    }else{
                        this.isnohistorydata = true;// 暂无数据
                    }
                }).catch(err => {
                    this.isnohistorydata = true;// 暂无数据
                    console.log(err);
                });
        },
        goExamresults(item){
          this.$router.push({
              // path: val.isValid ? "/examresults" : '/examIsValid',
              path: "/examresults",
              query: {
                  id: item.id,
                  trainItemExamId: this.filter.id,
                  type: "historical",
                  businessId: this.trainId,
                  businessType:  this.getexamparams.type,
                  backType: this.$route.query.backType,
                  showbtn: false,
                  backPath: this.$route.query.backPath,
                  goodsId:this.$route.query.goodsId,
                  goodsKind:this.$route.query.goodsKind,
              }
          });
        },
        examResultsUrl(id, val) {
            console.log('查看详情',val)
            // isReadOver 是否批阅(0:否;1:是)
            if(val.commitStatus === 2){
              let params = {
                  userPaperId: val.id,
              }
              this.$api.exam
              .findUserPaperSurface(params)
              .then((res) => {
                  if(res.code === 50001){
                    this.$toast({
                        message:res.message,
                        className:'examToast'
                    });
                  }else{
                    this.goExamresults(val)
                  }
              }).catch(err => {
                  console.log(err,'errr')
              })
              
            }else if ((val.paperType == 4 || val.paperType == 3 || val.paperType == 2) &&!val.isReadOver) {
                this.$toast('阅卷中，请耐心等待');
            } else {
                if( val.paperType == 2){
                     this.$toast('请去电脑端查看');
                } else {
                    this.goExamresults(val)
                }
            }
        },
        async findBasicExamById(){
            const params = {
                id:this.getexamparams.contentId || this.getexamparams.trainItemExamId,
                businessType: this.getexamparams.type,
                businessId: this.getexamparams.trainId,
            }
            await this.$api.exam.findBasicExamById({params}).then(res => {
                console.log(res,'res===')
                if(res.data){
                  this.isPop = res.data.pop;
                  this.userPaperId = res.data.userPaperId;
                  sessionStorage.setItem('readingtext',res.data.notes);
                }
            })
        },
        async joinexam(){
            try{
                const params = {
                  businessType:this.getexamparams.type,
                  examId:this.getexamparams.contentId || this.getexamparams.trainItemExamId,
                  businessId:this.getexamparams.trainId,
                  channel:2,// 考试来源  0 小程序，1 电脑，2 H5'
                  userPaperId:this.userPaperId
                }
                await this.$api.exam.joinexam({params}).then(res => {
                  if(res.data){
                    if(res.data.beLate){
                        this.$toast('您已超过最迟开考时间');
                    } else {
                        this.$router.push({
                            path:'/examTaking',
                            query:{
                                userPaperId: res.data.userPaperId, // 考试id
                                seconds: res.data.seconds === null ? 900 : res.data.seconds, // 考试允许用时
                                allowCommitDuration: res.data.allowCommitDuration === null ? 13 : res.data.allowCommitDuration, // 允许交卷时长(单位:分; 0:无, 默认值0)
                                businessType: this.getexamparams.type,
                                businessId:this.getexamparams.trainId,
                                trainItemExamId:this.getexamparams.trainItemExamId,
                                examId: this.examdata.examId,
                                backType: this.$route.query.backType,
                                backPath: this.$route.query.backPath,
                                goodsId:this.$route.query.goodsId,
                                goodsKind:this.$route.query.goodsKind,
                            }
                        })
                        localStorage.setItem('faceidentify',0)
                        // 考试允许用时
                        sessionStorage.setItem('secondsExam',JSON.stringify(res.data.seconds));
                        // 允许交卷时长(单位:分;0:无,默认值0)
                        sessionStorage.setItem('allowCommitDurationExam',JSON.stringify(res.data.allowCommitDuration));
                    }
                  }
                  
                })
                
            }catch(error){
                console.debug(error)
            }
        },
        async exampath(type) {
            const params = {
                id:this.getexamparams.contentId || this.getexamparams.trainItemExamId,
                businessType: this.getexamparams.type,
                businessId: this.getexamparams.trainId,
            }
            const res = await this.$api.exam.findBasicExamById({params})
            if(res.data){
                this.isPop = res.data.pop;
                this.userPaperId = res.data.userPaperId;
                sessionStorage.setItem('readingtext',res.data.notes);
            }
            if(res.code!=0) return
            /**
             * 进入考试 上锁状态增加提示语
             */
            if(this.examdata.isLocked && type){
                if (this.examdata.lockCourseRate && this.examdata.lockExamCondition) {
                    this.lockedTip = `该考试未开启，开启条件为前面的课程学习进度达到 ${this.examdata.lockCourseRate}%，考试及格`;
                } else if (this.examdata.lockCourseRate) {
                    this.lockedTip = `该考试未开启，开启条件为前面的课程学习进度达到 ${this.examdata.lockCourseRate}%`;
                } else if (this.examdata.lockExamCondition) {
                    this.lockedTip = `该考试未开启，开启条件为前面的考试及格`;
                }
                this.count=2;
                this.lockedTipDialog=true;
                return false;
            }
            // paperType 内容类型(1:试卷;2:实训)
            if(this.examdata.isOpenPCCamera || this.examdata.paperType == 2){
                this.$toast({
                    message:'该考试只能在电脑端，请更换设备考试',
                    className:'examToast'
                });
                return false
            }
            if(this.examdata.beLate && !this.isPop){
                this.$toast('您已超过最迟开考时间');
                return false;
            }
            if(this.stopClickLogin){
                 return false
            }
            this.stopClickLogin=true
            setTimeout(()=>{
              this.stopClickLogin=false
           },5000)
            let realarr = [+this.examdata.isFaceRecogBeforeExam, +this.examdata.isFaceRecogCommitExam, +this.examdata.isFaceRecogDuringExam]
            let needface = realarr.some(item => {
                return item === 1;
            })
            // 是否实名 没有设置人脸识别，就不校验实名认证，如果设置了人脸识别，就必现实名认证过才能考试
            //
            if (!needface || !+this.examdata.isFaceRecogBeforeExam && this.isReal) {
                if(this.isPop){
                  this.$dialog.alert({
                      confirmButtonText:'继续考试',
                      className:'dialogAlert',
                      title:'提示',
                      message: '检测到您有一场正在进行中的考试，防止考试异常，考试期间切勿离开',
                  }).then(async() => {
                    await this.joinexam()
                  })
                }else {
                  this.$router.push({
                      path: "/reading",
                      query: {
                          businessType: this.getexamparams.type,
                          businessId: this.getexamparams.trainId,
                          trainItemExamId: this.filter.id,
                          examId: this.examdata.examId,
                          backType: this.$route.query.backType,
                          backPath: this.$route.query.backPath,
                          goodsId:this.$route.query.goodsId,
                          goodsKind:this.$route.query.goodsKind,
                      }
                  });
                }
                
            } else {
                if (this.isReal) {
                    if(+localStorage.getItem('faceidentify')===1 && this.isPop){
                      this.$dialog.alert({
                          confirmButtonText:'继续考试',
                          className:'dialogAlert',
                          title:'提示',
                          message: '检测到您有一场正在进行中的考试，防止考试异常，考试期间切勿离开',
                      }).then(async() => {
                        await this.joinexam()
                      })
                    }else {
                      this.isfacedialog = true;
                      this.faceType = '1'
                    }
                    
                } else {
                    this.$router.push({
                        path: "/idcard",
                        query: {
                            backType: this.$route.query.backType,
                            trainItemExamId: this.$route.query.trainItemExamId,
                            type: this.$route.query.type,
                            contentId: this.$route.query.contentId,
                            trainId: this.$route.query.trainId,
                        }
                    }); // 跳转实名认证
                }
            }
        },
        close(val) {
            this.isfacedialog = val;
        },
        /**
         * 获取考试详情
         */
        findExamListByIds() {
            let params = {
                bussinessId: this.getexamparams.trainId,
                examId: this.getexamparams.contentId || this.getexamparams.trainItemExamId,
                type: this.getexamparams.type
            };
            this.$api.exam
                .findExamListByIds({
                    params
                })
                .then(data => {
                    this.examdataShow = true;
                    this.$nextTick(()=> {
                        let main = document.querySelector('.examination-record-content');
                        const h = window.innerHeight * 0.10;
                        main.style.paddingBottom = h + 'px';
                    })
                    this.examdata = data.data;
                    localStorage.setItem('isFaceRecogCommitExam', this.examdata.isFaceRecogCommitExam);
                    localStorage.setItem('isFaceRecogDuringExam', this.examdata.isFaceRecogDuringExam);
                });
        }
    }
};
</script>
<style>
.examToast{
    line-height: 40px !important;
}
.showclass .van-dialog__message {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #202124;
    line-height: 32px;
}
.showclass.van-dialog--round-button .van-dialog__footer {
    padding: 0;
    margin-bottom: 24px;
    width: 252px;
}
.showclass.van-dialog--round-button .van-dialog__confirm {
    border: 1px solid #415ff6 !important;
    color: #415ff6 !important;
    height: 2.1333rem !important;
    font-size: 0.8533rem !important;
}
</style>
<style lang='less' scoped>
@import '../asset/css/examListDetails';
.traindialog{
    width: 15.733rem;
    padding: 1.28rem;
    box-sizing: border-box;
    .van-dialog__content{
        text-align: center;
        .traindialog-content{
            font-size: 0.853rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #202124;
            line-height: 1.28rem;
            margin-bottom: 1.28rem;
        }
        .traindialog-btn{
            width: 100%;
            height: 2.1333rem;
            border-radius: 1.173rem;
            border: 0.026rem solid #415FF6;
            font-size: 0.853rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #415FF6;
            line-height: 2.1333rem;
            background: #FFFFFF;
            &::before{
                background-color: #FFFFFF;
            }
        }
    }
}

</style>
